module.exports = __webpack_public_path__ + "static/edo-ebot-26acf60fad3efb1c926247c600082158.jpg";